import { useState } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const faqs = [
  {
    q: '黑料718 是什么平台？',
    a: '黑料718是一个专注于正能量黑料内容精选与传播的独立平台。我们从海量信息中甄选积极向上、温暖人心的黑料故事，涵盖社会暖心事件、明星正能量八卦、职场励志爆料等多个领域。在这里，"黑料"不是阴暗面，而是发光发热的正能量载体，让读者在获取信息的同时收获温暖与力量。',
    icon: 'ri-question-answer-line',
  },
  {
    q: '平台上的内容是否真实可靠？',
    a: '每一条发布在黑料718上的内容都经过编辑团队的严格核实与多重审核。我们坚持真实、客观的原则，所有正能量故事均有可靠来源。平台已建立 AI 辅助审核与人工复核双重机制，内容真实率持续保持在 99.7% 以上，确保读者获取的信息准确可信。',
    icon: 'ri-shield-check-line',
  },
  {
    q: '如何向平台投稿或推荐黑料正能量故事？',
    a: '欢迎通过页面底部的"联系我们"模块提交投稿信息。您也可以将原创内容或故事线索发送至编辑团队邮箱。我们会在 48 小时内审阅并回复，优质投稿将获得首页推荐机会与相应稿酬奖励。期待每一位正能量传播者的参与。',
    icon: 'ri-mail-send-line',
  },
  {
    q: '黑料718 与其他八卦平台有什么本质区别？',
    a: '传统八卦平台往往聚焦负面爆料、明星黑料与争议事件。而黑料718坚持"正能量黑料"的独特定位——我们筛选的是有温度、有深度、有积极意义的爆料故事。同样是"料"，我们只选那些能给人带来力量、启发和温暖的。我们的使命是重新定义黑料行业的价值标准。',
    icon: 'ri-lightbulb-flash-line',
  },
  {
    q: '平台内容更新频率与运营节奏如何？',
    a: '黑料718保持每日高频更新的运营节奏，平均每天精选推送超过 50 条优质正能量内容。每周更新热门话题榜单与专题合集，每月推出深度策划的焦点专题。读者热评区实时展示最新精选互动，确保您每次访问都有新鲜的正能量内容等待发现。',
    icon: 'ri-refresh-line',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { ref, isVisible } = useScrollReveal(0.1);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-secondary-600 bg-secondary-100/60 px-3 py-1 rounded-full mb-3">
            帮助中心
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于黑料718，您可能想了解的问题都在这里
          </p>
        </div>

        <div className={`space-y-4 transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`bg-background-100 border rounded-xl overflow-hidden transition-all duration-300 ${
                openIndex === i
                  ? 'border-primary-300/60 shadow-sm'
                  : 'border-background-200/70'
              }`}
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer hover:bg-background-200/30 transition-colors group"
              >
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors ${
                  openIndex === i
                    ? 'bg-primary-100 text-primary-600'
                    : 'bg-background-200/70 text-foreground-500 group-hover:bg-primary-100 group-hover:text-primary-600'
                }`}>
                  <i className={`${faq.icon} text-lg`}></i>
                </div>
                <h3 className="flex-1 text-sm md:text-base font-heading font-medium text-foreground-900">
                  {faq.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === i ? 'rotate-180 text-primary-500' : 'text-foreground-400'
                }`}>
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </button>
              <div
                className={`grid transition-all duration-300 ${
                  openIndex === i ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                }`}
              >
                <div className="overflow-hidden">
                  <div className="px-5 md:px-6 pb-5 md:pb-6 pl-[66px] md:pl-[72px]">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}